import { Game } from "../Model/Game";
export class GamesFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createGame(id, code, roomId, managerId, creationDate, type, state, waitTime, numbers, useCheckers, playWithPaper) {
        return new Game(this.eventsChannelFactory, id, code, roomId, managerId, creationDate, type, state, waitTime, numbers, useCheckers, playWithPaper);
    }
    createGameFromDto(dto) {
        return this.createGame(dto.id, dto.code, dto.roomId, dto.managerId, dto.creationDate, dto.type, dto.state, dto.waitTime, dto.numbers, dto.useCheckers, dto.playWithPaper);
    }
}
